/*
 * Sort Inventory Panel Items by Size
 *
 **/
custom.inventoryPanelSort = (() => {
  function inventorySort($inventoryItem, $container) {
    const $variants = $inventoryItem;
    let sortedVariants = [];
    $variants.each(function () {
      const $v = $(this);
      const inventory = $v.data('inventory');
      const outOfStock = inventory <= 0 ? true : false;
      const inv_text = $v.find('.inventory-panel__variant-quantity').text();
      const variantID = $v.find('.js-table-variant-identifier').length
        ? $v.find('.js-table-variant-identifier').data('variant-identifier')
        : null;
      const price = variantID
        ? $v.find('.js-table-variant-identifier').text()
        : null;
      const map_price = variantID
        ? $v.find('.inventory-panel__variant-map').text()
        : null;
      const oakSet = $v.data('oak') ? `max="1"` : '';
      let priceContent;
      let mapContent = '';
      let incDecContent = '';

      if (window.customerId) {
        if (variantID) {
          priceContent = `<span class="js-table-variant-identifier font-medium md-up:font-book" data-variant-identifier="${variantID}">${price}</span>`;
          if ($v.find('.inventory-panel__variant-map').length) {
            mapContent = `
            <td class="spacer--2--py hidden md-up:table-cell inventory-panel__variant-map medium-up--text-center">
              ${map_price}
            </td>`;
          }
          incDecContent = `
          <td class="spacer--2--py hidden medium-up--text-center md-up:table-cell">
          <div class="input-number input-number--xsmall input-number--transparent js-form-numbers">
              <input type="number" id="Quantity_${variantID}" name="${variantID}" value="0" min="0" ${oakSet}>
              <span class="input-number__button minus">-</span>
              <span class="input-number__display"></span>
              <span class="input-number__button plus">+</span>
            </div>
          </td>
          `;
        } else {
          priceContent = 'Price is not available';
        }
      } else {
        priceContent = 'Sign in to view pricing details';
      }
      const variantObj = {
        size: $v.find('.inventory-panel__variant-name strong').text(),
        sku: $v.data('sku'),
        oakSet: $v.data('oak') ? `max="1"` : '',
        inventory: inventory,
        inv_text: inv_text,
        restock_class: outOfStock ? 'js-restock-date-inventory' : '',
        eta: '',
        lead_time: '',
        variant_identifier: $v.find('.js-table-variant-identifier').length
          ? $v.find('.js-table-variant-identifier').data('variant-identifier')
          : '',
        price: $v.find('.js-table-variant-identifier').length
          ? $v.find('.js-table-variant-identifier').text()
          : '',
        l_code: $v.data('l-code'),
        priceContent: priceContent,
        mapContent: mapContent,
        mapPrice: map_price,
        incDecContent: incDecContent,
        hide_if_no_eta: $v.is('[data-hide-if-no-eta]'),
        is_hidden: $v.css('display') === 'none',
      };
      sortedVariants.push(variantObj);
    });

    sortedVariants = sortedVariants.sort((a, b) => {
      return (
        custom.algoliaUtils.getSizeNum(a.size) -
        custom.algoliaUtils.getSizeNum(b.size)
      );
    });

    $container.html(
      sortedVariants.map((item) => {
        return `
          <tr class="inventory-panel__variant-item" data-inventory="${
            item.inventory
          }" data-sku="${item.sku}" data-eta="${item.eta}" data-l-code="${
          item.l_code
        }"${item.hide_if_no_eta ? ' data-hide-if-no-eta' : ''}${
          item.is_hidden ? ' style="display:none"' : ''
        }>
          <td class="spacer--2--py inventory-panel__variant-name"><strong>${
            item.size
          }</strong><br>
            <span class="inventory-panel__variant-quantity ${
              item.restock_class
            }" data-eta="${item.eta}" data-lead-time="${
          item.lead_time
        }" data-sku="${item.sku}">
              ${item.inv_text}
            </span>
          </td>
          <td class="spacer--2--py inventory-panel__variant-price text-capitalize text-right medium-up--text-center pr-6 md-up:pr-0">${
            item.priceContent
          }<span class="block md-up:hidden">${item.mapPrice || ''}</span></td>
          ${item.mapContent}
          ${item.incDecContent}
          <td class="spacer--2--py hidden md-up:table-cell text-right">${
            item.l_code
          }</td>
          </tr>
        `;
      }),
    );
  }

  return {
    inventorySort,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/inventory-panel-sort.js